export class ModalitaPagamentoService {
    private MODALITA_PAGAMENTO_TYPE: Record<string, string> = {
        'MP01': 'Pagamento con contanti',
        'MP02': 'assegno',
        'MP03': 'assegno circolare',
        'MP04': 'contanti presso Tesoreria',
        'MP05': 'Pagamento con bonifico',
        'MP06': 'vaglia cambiario',
        'MP07': 'bollettino bancario',
        'MP08': 'carta di pagamento',
        'MP09': 'RID',
        'MP10': 'RID utenze',
        'MP11': 'RID veloce',
        'MP12': 'RIBA',
        'MP13': 'MAV',
        'MP14': 'quietanza erario',
        'MP15': 'giroconto su conti di contabilità speciale',
        'MP16': 'domiciliazione bancaria',
        'MP17': 'domiciliazione postale',
        'MP18': 'Bollettino di c/c postale',
        'MP19': 'SEPA Direct Debit',
        'MP20': 'SEPA Direct Debit CORE',
        'MP21': 'SEPA Direct Debit B2B',
        'MP22': 'Trattenuta su somme riscosse',
        'MP23': 'PagoPA'
    };

    getTypes(): Record<string, string> {
        return this.MODALITA_PAGAMENTO_TYPE;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/data/modalita-pagamento.service.ts